import * as L from 'leaflet';
import { Feature, FeatureCollection } from 'geojson';
import { bboxPolygon, booleanDisjoint } from '@turf/turf';
import { Subject, Subscription, debounceTime } from 'rxjs';
import { VIEWPORT_BBOX_DEBOUNCE_MS } from './viewport-wfs.service';

/** The full-scene matches supply the count; only intersecting geometry is rendered. */
export class ObservationViewportController {
  private readonly changes$ = new Subject<void>();
  private readonly subscription: Subscription;

  constructor(
    private readonly map: L.Map,
    private readonly layer: L.GeoJSON,
    private features: Feature[]
  ) {
    this.subscription = this.changes$.pipe(debounceTime(VIEWPORT_BBOX_DEBOUNCE_MS))
      .subscribe(() => this.render());
    map.on('moveend', this.onMoveEnd);
    map.on('zoomend', this.onMoveEnd);
    this.render();
  }

  destroy(): void {
    this.map.off('moveend', this.onMoveEnd);
    this.map.off('zoomend', this.onMoveEnd);
    this.subscription.unsubscribe();
    this.changes$.complete();
    this.features = [];
  }

  private readonly onMoveEnd = (): void => this.changes$.next();

  private render(): void {
    const bounds = this.map.getBounds();
    const viewport = bboxPolygon([bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()]);
    const collection: FeatureCollection = {
      type: 'FeatureCollection',
      features: this.features.filter((feature) => {
        if (!feature.geometry) return false;
        try {
          return !booleanDisjoint(feature, viewport);
        } catch {
          return false;
        }
      }),
    };
    this.layer.clearLayers();
    this.layer.addData(collection);
  }
}
